<div *ngIf="vm" id="participant-form-panel-header-component">
  <h1>
    <span>{{ vm.title }}</span>
  </h1>
</div>
